import { screenReaderTalkPolite } from './screenreader'

const showSuccess = (boxId: string) => {
  const box = document.getElementById(boxId)
  const boxCopy = <HTMLElement>box.cloneNode(true)
  box.parentNode.replaceChild(boxCopy, box)

  if (!boxCopy.classList.contains('animate')) {
    boxCopy.classList.add('animate')
  }

  const messageText = box.innerText

  screenReaderTalkPolite(messageText)
}

const copyTextToClipboard = async (text: string): Promise<void> => {
  try {
    // Try to use modern Clipboard API first
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text)
      return
    }

    // If Clipboard API is not supported, use fallback
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()

    const success = document.execCommand('copy')
    document.body.removeChild(textarea)

    if (!success) {
      throw new Error('execCommand copy failed')
    }
  } catch (err) {
    console.error('Clipboard operation failed:', err)
    throw err
  }
}

export const setTextToClipboard = (text: string, successMessageId: string) => {
  copyTextToClipboard(text)
    .then(() => {
      showSuccess(successMessageId)
    })
    .catch((err) => {
      console.error('Failed to copy:', err)
      if (!document.queryCommandEnabled('copy')) {
        alert('Copying to clipboard is not supported on your browser.')
      }
    })
}
